/* eslint-disable spaced-comment */
import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router";

import SplashScreen from "src/components/SplashScreen";

import {logout, setUserData} from "src/actions/accountActions";

import {requestForToken} from "src/config/firebase";
import {FCM_TOKEN_LOCAL_STORAGE} from "src/constants";
import authService from "src/services/authService";

function Auth({children}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        const userId = localStorage.getItem("userId");
        const fcmTokenLocal = localStorage.getItem(FCM_TOKEN_LOCAL_STORAGE);

        const fcmToken = await requestForToken();
        const response = await authService.loginInWithToken(userId);
        if (response.code === "success" && fcmToken === fcmTokenLocal) {
          await dispatch(setUserData(response.data));
        }
        if (response?.status === 401) {
          history.push("/login");
          authService.logout();
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
